export enum TriggerTypes {
  newViolationFound = 'newViolationFound',
  newResourceFound = 'newResourceFound',
  newOrExistingViolationFound = 'newOrExistingViolationFound',
  newOrExistingResourceFound = 'newOrExistingResourceFound',
  existingViolationFound = 'existingViolationFound',
  existingResourceFound = 'existingResourceFound',
  newFindingFound = 'newFindingFound',
  newIssueFound = 'newIssueFound',
}
